import mapItemToCartItem from '@/helpers/mapItemToCartItem'

function recalculateCartTotal (state) {
  state.total = state.items.reduce((sum, item) => sum + item.cant * item.precio, 0)
}

function productosSignature (productos) {
  return (productos || [])
    .map(p => `${p.id}:${p.cant}`)
    .sort()
    .join('|')
}

function isSameCartLine (a, b) {
  if (a.productId !== b.productId) return false
  if (!!a.esCombinado !== !!b.esCombinado) return false
  if (!!a.esEstatico !== !!b.esEstatico) return false
  const obsA = (a.observaciones || '').trim()
  const obsB = (b.observaciones || '').trim()
  if (obsA !== obsB) return false
  if (a.esCombinado || a.esEstatico) {
    return productosSignature(a.productos) === productosSignature(b.productos)
  }
  return true
}

const mutations = {
  setItem (state, item) {
    const cartItem = mapItemToCartItem(item)
    const existingIndex = state.items.findIndex(i => isSameCartLine(i, cartItem))
    if (existingIndex > -1) {
      state.items[existingIndex].cant += cartItem.cant
    } else {
      state.items.push(cartItem)
    }
  },
  setItems (state, items) {
    state.items.concat(items)
  },
  eraseItem (state, itemToRemove) {
    for (let i = 0; i < state.items.length; i++) {
      if (state.items[i]._id === itemToRemove._id) { state.items.splice(i, 1) }
    }
  },
  eraseItemCarta (state, itemToRemove) {
    for (let i = 0; i < state.items.length; i++) {
      if (state.items[i].productId === itemToRemove.id) { state.items.splice(i, 1) }
    }
  },
  calculateAmountWhenItemIsAdded (state) {
    recalculateCartTotal(state)
  },
  adjustLineQuantity (state, { _id, delta }) {
    const idx = state.items.findIndex((i) => i._id === _id)
    if (idx === -1) return
    const item = state.items[idx]
    const newCant = item.cant + delta
    if (newCant <= 0) {
      state.items.splice(idx, 1)
    } else {
      state.items[idx].cant = newCant
    }
    recalculateCartTotal(state)
  },
  calculateAmountWhenItemIsRemoved (state, itemToRemove) {
    state.total -= (itemToRemove.cant * itemToRemove.precio)
  },
  resetItems (state) {
    state.items = []
    state.total = 0
  },
  editItem (state, params) {
    const existingItem = state.items.findIndex(i => i.productId === params.id)
    if (existingItem > -1) {
      const item = state.items[existingItem]
      item.canApplyDiscoint = params.applyDiscoint
      state.items[existingItem] = item
    }
  }
}

export default mutations
